(() => {
  'use strict';
  const root = document.querySelector('[data-morgasm-root]');
  const dataNode = document.getElementById('clc-commerce');
  if (!root || !dataNode) return;
  const data = JSON.parse(dataNode.textContent);
  const local = document.body.dataset.localQa === 'true';
  // A fixture must never make a request to Shopify, even if copied by mistake.
  if (data.source === 'local-fixture-only' && !local) throw new Error('Local fixture refused outside the local preview.');
  const media = matchMedia('(min-width:1200px)');
  const state = {mode: 'subscription', weeks: '4', variantId: String(data.selectedVariantId), gallery: 0, guidance: 0, busy: false, uncertain: false, open: new Map()};
  const $ = (selector, scope = root) => scope.querySelector(selector);
  const $$ = (selector, scope = root) => [...scope.querySelectorAll(selector)];
  const money = value => new Intl.NumberFormat(data.locale || 'en-US', {style: 'currency', currency: data.currency}).format(value / 100);
  const variant = () => data.variants.find(v => String(v.id) === state.variantId);
  const allocation = (weeks = state.weeks) => {
    const id = data.binding.plans[weeks];
    const groupId = data.binding.groups?.[weeks];
    if (!id || !groupId) return null;
    return variant()?.allocations.find(a => String(a.id) === String(id) && String(a.groupId) === String(groupId) && a.recurring === true && Number.isFinite(a.price)) || null;
  };
  const route = suffix => `${String(data.root || '/').replace(/\/$/, '')}/${suffix}`;
  const cartDialog = document.getElementById('clc-cart');
  const menuDialog = document.getElementById('clc-menu');
  let restoreFocus;
  let activeLayout;
  let resizeObserver;
  let frame;
  const setStatus = message => {
    const status = $('[data-status]');
    status.textContent = message;
    status.hidden = !message;
  };
  function updateCommerce() {
    const v = variant();
    const plan = allocation();
    $$('[data-mode]').forEach(card => {
      const selected = card.dataset.mode === state.mode;
      card.classList.toggle('on', selected);
      $('.dot', card).classList.toggle('on', selected);
      $('input', card).checked = selected;
      $('input', card).disabled = card.dataset.mode === 'once' && data.requiresSellingPlan;
    });
    const frequency = $('.freq:not([data-variant])');
    const options = ['4', '6', '8'].map(weeks => ({weeks, plan: allocation(weeks)}));
    frequency.replaceChildren(...options.map(({weeks, plan: p}) => {
      const option = new Option(p ? p.name : `${weeks} weeks unavailable`, weeks);
      option.disabled = !p;
      return option;
    }));
    frequency.value = state.weeks;
    frequency.disabled = !options.some(x => x.plan);
    $('[data-freq]').hidden = state.mode !== 'subscription';
    $('[data-price-once]').textContent = v ? money(v.price) : 'Unavailable';
    $('[data-price-subscription]').textContent = plan ? money(plan.price) : 'Unavailable';
    $('[data-price-compare]').textContent = plan ? money(plan.compareAtPrice) : '';
    const saving = plan && plan.compareAtPrice > 0 ? Math.round(100 * (1 - plan.price / plan.compareAtPrice)) : 0;
    $('[data-saving]').textContent = saving > 0 ? `SAVE ${saving}%` : 'SUBSCRIBE';
    $('[data-saving-copy]').textContent = saving > 0 ? `${saving}% off every order` : 'Recurring delivery';
    const blocked = !v?.available || (state.mode === 'subscription' && !plan) || (state.mode === 'once' && data.requiresSellingPlan);
    $$('[data-add]').forEach(button => {
      button.disabled = blocked || state.busy || state.uncertain;
      button.setAttribute('aria-busy', String(state.busy));
      button.textContent = state.busy ? 'ADDING…' : 'ADD TO BAG';
    });
    if (!v?.available) setStatus('This option is currently sold out.');
    else if (state.mode === 'subscription' && !plan) setStatus('Subscriptions are currently unavailable. Please choose one-time purchase.');
    else if (state.mode === 'once' && data.requiresSellingPlan) setStatus('This product requires a subscription.');
    else if (!state.uncertain) setStatus('');
  }
  function updateGallery() {
    $$('[data-slide]').forEach((slide, i) => { slide.style.display = i === state.gallery ? 'block' : 'none'; });
    $$('[data-thumb]').forEach((thumb, i) => {
      thumb.classList.toggle('on', i === state.gallery);
      thumb.setAttribute('aria-pressed', String(i === state.gallery));
    });
  }
  function updateGuidance() {
    $$('.seg button').forEach((tab, i) => {
      tab.setAttribute('aria-selected', String(i === state.guidance));
      tab.tabIndex = i === state.guidance ? 0 : -1;
    });
    $$('[data-steps]').forEach((panel, i) => { panel.hidden = i !== state.guidance; panel.style.display = i === state.guidance ? 'grid' : 'none'; });
  }
  function sticky() {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      const bar = $('[data-pagesmith-sticky]');
      if (!bar) return;
      const start = $('#m-sticky-start');
      const on = !media.matches && start.getBoundingClientRect().bottom < 0;
      bar.classList.toggle('on', on);
      bar.setAttribute('aria-hidden', String(!on));
      bar.inert = !on;
      // Keep the last footer links reachable while the persistent bar is visible.
      document.body.style.paddingBottom = on ? `${bar.getBoundingClientRect().height}px` : '';
      root.style.setProperty('--clc-sticky-space', '0px');
    });
  }
  function showDialog(dialog, opener) {
    if (!dialog) return;
    restoreFocus = opener || document.activeElement;
    dialog.showModal();
    document.body.style.overflow = 'hidden';
    dialog.querySelector('[data-close]')?.focus();
  }
  [cartDialog, menuDialog].filter(Boolean).forEach(dialog => {
    dialog.querySelector('[data-close]')?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => { document.body.style.overflow = ''; if (restoreFocus?.isConnected) restoreFocus.focus(); });
    dialog.addEventListener('click', event => { if (event.target === dialog && event.clientX < dialog.getBoundingClientRect().left) dialog.close(); });
  });
  async function request(suffix, options = {}) {
    if (local && !['localhost', '127.0.0.1', '[::1]'].includes(location.hostname)) throw new Error('Local QA requests require localhost.');
    const response = await fetch(route(suffix), {credentials: 'same-origin', cache: 'no-store', ...options});
    const result = await response.json();
    if (!response.ok) {
      const error = new Error(result.description || result.message || 'Your bag could not be updated. Please try again.');
      error.rejected = true;
      throw error;
    }
    return result;
  }
  function renderCart(cart) {
    const content = cartDialog?.querySelector('[data-cart-content]');
    if (!content) return;
    content.replaceChildren();
    const cartMoney = value => new Intl.NumberFormat(data.locale || 'en-US', {style: 'currency', currency: cart.currency || data.currency}).format(value / 100);
    if (!cart.items.length) content.textContent = 'Your bag is empty.';
    cart.items.forEach(item => {
      const line = document.createElement('div');
      line.className = 'cart-line';
      line.dataset.lineKey = item.key;
      const values = [item.product_title || item.title, item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '', item.selling_plan_allocation?.selling_plan?.name || 'One-time purchase', `Quantity: ${item.quantity}`, cartMoney(item.final_line_price)];
      values.filter(Boolean).forEach(value => { const p = document.createElement('p'); p.textContent = value; line.append(p); });
      content.append(line);
    });
    (cart.cart_level_discount_applications || []).forEach(discount => {
      const line = document.createElement('p');
      line.className = 'cart-discount';
      line.textContent = `${discount.title}: -${cartMoney(discount.total_allocated_amount)}`;
      content.append(line);
    });
    const total = document.createElement('p');
    total.className = 'cart-total';
    total.textContent = `${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'} · Total ${cartMoney(cart.total_price)}`;
    content.append(total);
  }
  async function openCart(opener) {
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {detail: {opener}}));
  }
  async function addToCart(opener) {
    if (state.busy || state.uncertain || opener.disabled) return;
    const v = variant();
    const plan = allocation();
    if (!v?.available || (state.mode === 'subscription' && !plan)) return;
    const item = {id: v.id, quantity: 1};
    if (state.mode === 'subscription') item.selling_plan = plan.id;
    state.busy = true;
    updateCommerce();
    let accepted = false;
    try {
      const drawer = document.querySelector('cart-drawer');
      const sections = drawer?.getSectionsToRender?.().map(section => section.section) || [];
      const result = await request('cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({items: [item], sections, sections_url: location.pathname})});
      accepted = true;
      if (drawer?.renderContents && sections.every(id => result.sections?.[id])) await drawer.renderContents(result, true);
      else {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {detail: {opener}}));
      }
      document.dispatchEvent(new CustomEvent('clc:cart-updated', {detail: {cart: result}}));
    } catch (error) {
      // Never automatically retry an ambiguous POST or encourage another add after a read failure.
      state.uncertain = accepted || !error.rejected;
      setStatus(state.uncertain ? 'Your bag may have been updated. Open the bag to check before adding again.' : error.message);
    } finally {
      state.busy = false;
      const message = $('[data-status]').textContent;
      updateCommerce();
      if (message) setStatus(message);
    }
  }
  function mount() {
    const layout = media.matches ? 'desktop' : 'mobile';
    if (activeLayout === layout) return;
    activeLayout = layout;
    resizeObserver?.disconnect();
    root.replaceChildren(document.getElementById(`clc-${layout}`).content.cloneNode(true));
    root.dataset.layout = layout;
    const vSelect = $('[data-variant]');
    vSelect.replaceChildren(...data.variants.map(v => new Option(v.title, String(v.id))));
    vSelect.value = state.variantId;
    $('[data-variants]').hidden = data.variants.length <= 1;
    vSelect.addEventListener('change', () => { state.variantId = vSelect.value; updateCommerce(); });
    $$('[data-mode]').forEach(card => {
      card.addEventListener('click', event => {
        if (event.target.closest('select') || $('input', card).disabled) return;
        state.mode = card.dataset.mode;
        updateCommerce();
      });
      $('input', card).addEventListener('change', () => { state.mode = card.dataset.mode; updateCommerce(); });
    });
    $('.freq:not([data-variant])').addEventListener('change', event => { state.weeks = event.target.value; updateCommerce(); });
    $$('[data-thumb]').forEach((thumb, i) => thumb.addEventListener('click', () => { state.gallery = i; updateGallery(); }));
    const accordions = $$('.tab-h,.faq-t');
    accordions.forEach((button, index) => {
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      // One open panel across both product information and FAQ groups.
      const open = state.open.size ? state.open.get(index) === true : index === 0;
      button.setAttribute('aria-expanded', String(open)); panel.hidden = !open;
      button.addEventListener('click', () => {
        const next = button.getAttribute('aria-expanded') !== 'true';
        accordions.forEach((other, otherIndex) => {
          const expanded = otherIndex === index && next;
          other.setAttribute('aria-expanded', String(expanded));
          document.getElementById(other.getAttribute('aria-controls')).hidden = !expanded;
          state.open.set(otherIndex, expanded);
        });
        sticky();
      });
    });
    $$('.seg button').forEach((tab, i) => {
      tab.addEventListener('click', () => { state.guidance = i; updateGuidance(); });
      tab.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        state.guidance = event.key === 'Home' ? 0 : event.key === 'End' ? 1 : 1 - state.guidance;
        updateGuidance(); $$('.seg button')[state.guidance].focus();
      });
    });
    $$('[data-add]').forEach(button => button.addEventListener('click', () => addToCart(button)));
    $('[data-menu-open]')?.addEventListener('click', event => showDialog(menuDialog, event.currentTarget));
    $('[data-cart-open]')?.addEventListener('click', event => openCart(event.currentTarget));
    if (local) $('[data-newsletter]').addEventListener('submit', event => {
      event.preventDefault();
      const status = $('[data-newsletter-status]'); status.hidden = false;
      status.textContent = 'Local preview: email format accepted. Nothing was submitted.';
    });
    updateCommerce(); updateGallery(); updateGuidance(); sticky();
    resizeObserver = new ResizeObserver(sticky); resizeObserver.observe(root);
    if (state.uncertain) setStatus('Your bag may have been updated. Open the bag to check before adding again.');
  }
  media.addEventListener('change', mount);
  window.addEventListener('scroll', sticky, {passive: true});
  window.addEventListener('resize', sticky, {passive: true});
  mount();
})();
